<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1600"
        v-model="PDFView.isOpenViewDialog"
        eager
        persistent
        scrollable
    >
        <v-card>
            <v-toolbar flat dark></v-toolbar>
            <div class="pa-3" style="overflow-y: scroll">
                <LoadingSkeleton
                    v-if="PDFView.isLoadingHtmlOffer && !isOfertaAntigua(offer)"
                    style="width: 100%; height: 100%"
                />
                <iframe
                    frameBorder="0"
                    v-show="
                        !PDFView.isLoadingHtmlOffer && !isOfertaAntigua(offer)
                    "
                    id="frameOferta"
                    ref="frameOferta"
                    style="width: 100%; overflow-y: scroll; height: 700px"
                ></iframe>
                <div
                    v-if="
                        offer &&
                        isOfertaAntigua(offer) &&
                        offer.paquetes.length > 0
                    "
                >
                    <div
                        v-for="(paquete, index) in offer.paquetes"
                        :key="index"
                    >
                        <h3
                            class="
                                pt-md-3
                                d-flex
                                justify-center
                                font-weight-light
                                grey--text
                            "
                        >
                            {{ paquete.unidadVentaDeprecated }}
                        </h3>
                        <v-divider class="mx-md-16"></v-divider>
                    </div>
                </div>
                <div v-else-if="offer && isOfertaAntigua(offer)">
                    <h2
                        class="
                            pt-md-3
                            d-flex
                            justify-center
                            font-weight-thin
                            grey--text
                        "
                    >
                        Venta No registrada
                    </h2>
                </div>
            </div>
            <v-progress-linear
                v-if="isLoadingDownloadPDF"
                color="#F50057"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
            <v-card-actions class="d-flex justify-end">
                <v-btn
                    v-if="
                        !isOfertaAntigua(offer) && !PDFView.isLoadingHtmlOffer
                    "
                    color="primary"
                    outlined
                    @click="downloadOfferPDF(offer.id)"
                    style="border: 0px !important"
                >
                    Descargar
                    <v-icon class="ml-2">mdi-download</v-icon>
                </v-btn>
                <v-btn color="red" text @click="closeDialog">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoadingSkeleton from '../ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'PDFView',
    data: () => ({}),
    components: {
        LoadingSkeleton,
    },
    props: {
        offer: null,
    },
    methods: {
        downloadOfferPDF(offerId) {
            this.$store.commit('util/isLoadingDownloadPDF', true);
            this.fetchPDFOffer(offerId).then(() => {
                this.$store.commit('util/isLoadingDownloadPDF', false);
            });
        },
        generateHtmlOffer() {
            this.$store.commit('util/PDFView', {
                isLoadingHtmlOffer: true,
                isOpenViewDialog: true,
                ofertaHtml: '',
            });

            if (!this.isOfertaAntigua(this.offer)) {
                setTimeout(
                    () =>
                        this.fetchHtmlOffer(this.offer.id).then(() => {
                            this.$store.commit('util/isLoadingPDFView', false);
                        }),
                    100
                );
            }
        },
        isOfertaAntigua(oferta) {
            if (oferta) {
                return (
                    !oferta.paquetes.length ||
                    oferta.paquetes.some(
                        ({ unidadVentaDeprecated }) =>
                            unidadVentaDeprecated != null
                    )
                );
            }
        },
        closeDialog() {
            this.$store.commit('util/PDFView', {
                isLoadingHtmlOffer: false,
                isOpenViewDialog: false,
                ofertaHtml: '',
            });
            this.$refs.frameOferta.contentDocument.close();
        },
        ...mapActions({
            fetchHtmlOffer: 'util/fetchHtmlOffer',
            fetchPDFOffer: 'util/fetchPDFOffer',
        }),
    },
    computed: {
        ...mapState('util', {
            PDFView: (state) => state.PDFView,
            ofertaHtml: (state) => state.PDFView.ofertaHtml,
            isLoadingDownloadPDF: (state) => state.isLoadingDownloadPDF,
        }),
    },
    watch: {
        ofertaHtml() {
            this.$refs.frameOferta.contentDocument.write('');
            this.$refs.frameOferta.contentDocument.write(
                this.PDFView.ofertaHtml
            );
        },
        offer() {
            this.generateHtmlOffer();
        },
    },
};
</script>